import React, { useEffect, useState} from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import GroupsIcon from '@mui/icons-material/Groups';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import baseURL from '../../config';


const DashBoard = () => {
  const navigate = useNavigate();
  const [vesselCount, setVesselCount] = useState(0);
  const {id: vesselownerId}= useParams();
  const [crewCount, setCrewCount] = useState(0);
const [contractCount, setContractCount] = useState(0);
const [bsmContractCount, setBsmContractCount] = useState(0);
const [assignedVesselCount, setAssignedVesselCount] = useState(0);

  // console.log('Vessel Owner ID:', vesselownerId);

  useEffect(() => {
    const token = localStorage.getItem("token");
  
    const fetchVesselData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/vesselOwner/getshipdetailsbyvesselownerId/${vesselownerId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setVesselCount(response.data?.count || 0);
      } catch (error) {
        console.error('Error fetching vessel data:', error);
      }
    };
  
    const fetchCrewData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/vesselownercrew/getCrewMemberById/${vesselownerId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log('Crew API response:', response.data); // Debug
        setCrewCount(response.data?.data?.length || 0);
      } catch (error) {
        console.error('Error fetching crew data:', error);
      }
    };
    
    const fetchAssignedVessels = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/vesselOwner/getAssignedVesselsByVesselOwnerId/${vesselownerId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setAssignedVesselCount(response.data?.count || 0);
      } catch (error) {
        console.error('Error fetching assigned vessels:', error);
      }
    };
    
  
    const fetchContractData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/vesselOwner/getVesselOwnerContractsByVesselOwnerId/${vesselownerId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setBsmContractCount(response.data?.count || 0);
      } catch (error) {
        console.error('Error fetching BSM contract data:', error);
      }
    };
    const fetchBsmContractData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/vesselOwner/getcontractforvesselownerafterForm1/${vesselownerId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setContractCount(response.data?.totalCount || 0);
      } catch (error) {
        console.error('Error fetching contract data:', error);
      }
    };
    
    if (vesselownerId) {
      fetchVesselData();
      fetchCrewData();
      fetchContractData();
      fetchBsmContractData();
      fetchAssignedVessels(); 
    }
  }, [vesselownerId]);
  
  const cardData = [
    { icon: <DirectionsBoatIcon fontSize="large" />, label: 'Vessels', value: vesselCount },
    { icon: <GroupsIcon fontSize="large" />, label: 'Crews', value: crewCount },
    { icon: <BusinessCenterIcon fontSize="large" />, label: 'Assigned Vessels', value: assignedVesselCount },
    { icon: <AssignmentTurnedInIcon fontSize="large" />, label: 'BSM Contracts', value: contractCount },
    { icon: <AssignmentTurnedInIcon fontSize="large" />, label: 'Contracts', value: bsmContractCount },
  ];
  

  return (
    <Box sx={{ p: 3, bgcolor: 'grey.100', minHeight: '100vh' }}>
      <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
        Overview
      </Typography>

      <Grid container spacing={3}>
        {cardData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                textAlign: 'center',
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'grey.300',
                transition: 'all 0.3s',
                '&:hover': { boxShadow: 6 },
                cursor: item.path ? 'pointer' : 'default',
              }}
              onClick={() => item.path && navigate(item.path)}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center', color: 'primary.main', mb: 1 }}>
                {item.icon}
              </Box>
              <Typography variant="h4" fontWeight="bold">
                {item.value}
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                {item.label}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DashBoard;
